import { buildUrl } from "./url";

describe("buildUrl", () => {
    it("creates url with a parameter", () => {
        expect(buildUrl("https://example.com", { q: "test" })).toEqual("https://example.com/?q=test");
    });

    it("creates url with multiple parameters", () => {
        expect(buildUrl("https://example.com/?x=1", { y: "test", z: "lorem" })).toEqual("https://example.com/?x=1&y=test&z=lorem");
    });

    it("works without paramters", () => {
        expect(buildUrl("https://example.com")).toEqual("https://example.com/");
    });

    it("can handle empty baseurl", () => {
        expect(buildUrl("")).toEqual("");
    });
});
